require("../../editor/common/services/editorSimpleWorker.ts")
module.exports = require("!!../../../../../../webpack/loaders/babel.js??ref--2-0!../../../../../../node_modules/ts-loader/index.js??ref--2-1!./workerMain.ts");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@timkendrick/monaco-editor-loader/lib/loaders/include.js?{"includes":["/Users/tim/Sites/@timkendrick/monaco-editor/submodules/vscode/src/vs/editor/common/services/editorSimpleWorker.ts"]}!./webpack/loaders/babel.js??ref--2-0!./node_modules/ts-loader??ref--2-1!./submodules/vscode/src/vs/base/worker/workerMain.ts
// module id = 107
// module chunks = 0